import { useCallback } from 'react'

import { type AlertActionPayload, SESSION_STORAGE_KEY } from '../AlertContext'

// Message is narrowed back to string here (AlertActionPayload allows ReactNode)
// The payload is JSON.stringify'd into sessionStorage, which can't survive a JSX value
export type StoredAlertPayload = Omit<AlertActionPayload, 'id' | 'timestamp' | 'message'> & { message: string }

export const useStoredAlert = () => {
  return useCallback((alert: StoredAlertPayload) => {
    sessionStorage.setItem(SESSION_STORAGE_KEY, JSON.stringify(alert))
  }, [])
}
